<template>
    <v-card
        class="mx-auto pa-5 overflow-visible"
        outlined
    >
        <div class="chart">
            <div class="chart-title chart-title--multiLine display-2">
                Doanh thu
            </div>
            <div class="chart-content">
                <div class="chart-item">
                    <span class="font-weight-bold">Doanh thu thành công</span>
                    <span class="chart-bg chart-bg--female"></span>
                </div>
                <div class="chart-item">
                    <span class="font-weight-bold">Doanh thu khởi tạo</span>
                    <span class="chart-bg chart-bg--female" style="background: #f4c63d"></span>
                </div>
            </div>
        </div>
        <chartist
            :data="multipleLine.data"
            :options="multipleLine.options"
            type="Line"
            style="max-height: 300px;"
            class="mt-10 chart-multi-revenue chart-fix"></chartist>
    </v-card>
</template>
<script>
    import * as ChartistTooltips from 'chartist-plugin-tooltips';
    export default {
        props: {
            dataChart: {
                type: Object,
                default: () => {},
            }
        },
        created () {
            this.multipleLine.data.series = [
                this.dataChart.successTurnOver.map(d => ({ meta: 'Doanh thu thành công (Triệu đồng):', value: d })),
                this.dataChart.initTurnOver.map(d => ({ meta: 'Doanh thu khởi tạo (Triệu đồng):', value: d })),
            ]
        },
        data() {
            return {
                multipleLine: {
                    data: {
                        labels: this.dataChart.labels,
                        series: [
                        ],
                    },
                    options: {
                        fullWidth: true,
                        low: 0,
                        axisY: {
                            onlyInteger: true,
                        },
                        chartPadding: {
                            top: 0,
                            right: 20,
                            bottom: 0,
                            left: 20,
                        },
                        plugins: [this.$chartist.plugins.tooltip()]
                    },
                },
            }
        },
    }
</script>

<style lang="scss">
    .chart-multi-revenue {
        .ct-series-a .ct-line, .ct-series-a .ct-point {
            stroke: #f44336!important
        }
        .ct-series-b .ct-line, .ct-series-b .ct-point {
            stroke: #f4c63d!important
        }
    }
</style>
